module.exports = __webpack_public_path__ + "static/media/path-4.4ea9d4f9.svg";